import React, { useEffect, useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import LoadingOverlay from 'components/LoadingOverlay';
import { Link, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getAgent } from 'api/agents';
import Container from 'components/Container';
import Button from 'components/Button';
import { addRecentItem } from 'helpers/recentItems';

export default function Agent() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const { agentId } = useParams();

    const { data: agent, isLoading } = useQuery({
        queryKey: ['agents', agentId],
        queryFn: async () => await getAgent({
            id: agentId
        }),
    });

    useEffect(() => {
        addRecentItem({
            type: 'agent',
            _id: agentId,
            name: agent?.name || 'Agente',
        });
    }, [agent, agentId]);

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] overflow-y-auto ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='text-center min-h-svh py-20 flex flex-col justify-center items-center'>
                        <div className='w-24 h-24 rounded-full bg-center bg-cover mx-auto mb-5' style={{ backgroundImage: `url(${agent?.image || '/images/agent-avatar.jpg'})` }}></div>
                        <h1 className='text-3xl font-medium text-black'>{agent?.name}</h1>
                        <p className='text-muted pt-2'>{agent?.description}</p>
                        <div className='flex justify-center pt-8'>
                            <Button component={Link} to={`/agents/${agent?.slug}/${agentId}`}>
                                Avvia agente
                            </Button>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
